"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Put your application javascript here
window.theme = window.theme || {};

(function ($) {
  'use strict';

  var config = {
    common: {
      storefrontApiUrl: '/api/2021-07/graphql.json'
    },
    // https://staging-api-2x7x5y6zta-ts.a.run.app
    staging: {
      apiUrl: 'https://staging-api-2x7x5y6zta-ts.a.run.app',
      storefrontAccessToken: '702c25d4573cb7a81c9e5e15820d7017'
    },
    production: {
      apiUrl: 'https://production-api-2x7x5y6zta-ts.a.run.app',
      storefrontAccessToken: '0ac12f1a30fe41c8b1a74e07875a97ee'
    }
  };
  var envConfig = window.location.hostname != 'fivesenses.com.au' ? config.staging : config.production; // envConfig = config.production;

  theme.ENV = $.extend(config.common, envConfig);
  theme.utils = {
    checkLuma: function checkLuma(color) {
      var rgb = color.substring(4, color.length - 1).replace(/ /g, '').split(',');
      var luma = 0.299 * parseInt(rgb[0]) + 0.587 * parseInt(rgb[1]) + 0.114 * parseInt(rgb[2]);

      if (luma < 186) {
        return true;
      }

      return false;
    },
    uuid: function uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    setCookie: function setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 60 * 60 * 1000); //1h

      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    },
    getCookie: function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return '';
    },
    formatDate: function formatDate(date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      return dd + '-' + mm + '-' + yyyy;
    },
    fetch: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url, options) {
      return new Promise(function (resolve, reject) {
        fetch(url, options).then(function (response) {
          response.json().then(function (data) {
            if (response.status >= 400) reject(data);else resolve(data);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }),
    fetchText: function fetchText(url, options) {
      return new Promise(function (resolve, reject) {
        fetch(url, options).then(function (response) {
          response.text().then(function (data) {
            if (response.status >= 400) reject(data);else resolve(data);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    },
    debounce: function debounce(func) {
      var _this = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
      var timer;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(_this, args);
        }, timeout);
      };
    },
    formatMoney: function formatMoney(money) {
      var formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      });
      return formatter.format(money);
    },
    getParameterByName: function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    serialize: function serialize(form, returnJson) {
      var arr = [];
      var json = {};
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;

        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            json[field.name] = option.value;
            arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
          });
          return;
        }

        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
        json[field.name] = field.value;
        arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });
      return returnJson ? json : arr.join('&');
    }
  };
  theme.a11y = {
    trapFocus: function trapFocus(options) {
      var element = typeof options.element === 'string' ? $(options.element) : options.element;
      var elementToFocus = typeof options.elementToFocus === 'string' ? $(options.elementToFocus) : options.elementToFocus; // Get every possible visible focusable element

      var focusableEls = element.find('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(function (el) {
        return el.offsetParent !== null;
      });
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!elementToFocus) {
        elementToFocus = element;
      }

      element.attr('tabindex', '-1');
      elementToFocus.focus();
      var $document = $(document.documentElement);
      $document.off('focusin');
      $document.on('focusout', function () {
        $document.off('keydown.handleFocus');
      });
      $document.on('focusin', function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
        $document.on('keydown.handleFocus', function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */

        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function removeTrapFocus(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.removeAttr('tabindex');
      el.off('focusin');
    },
    lockScrolling: function lockScrolling(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.addClass('lock-scroll');
      el.on('touchmove', function () {
        return true;
      });
    },
    unlockScrolling: function unlockScrolling(element) {
      var el = element ? typeof element === 'string' ? $(element) : element : $(document.documentElement);
      el.removeClass('lock-scroll');
      el.off('touchmove');
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function _createInstance(container, constructor) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
    _onSectionLoad: function _onSectionLoad(evt) {
      var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]');

      if (container) {
        this._createInstance(container);
      }
    },
    _onSectionUnload: function _onSectionUnload(evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },
    _onSelect: function _onSelect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function _onDeselect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function _onBlockSelect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function _onBlockDeselect(evt) {
      var instance = this.instances.find(function (instance) {
        return instance.id === evt.detail.sectionId;
      });

      if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
    register: function register(type, constructor) {
      this.constructors[type] = constructor;
      document.querySelectorAll('[data-section-type="' + type + '"]').forEach(function (container) {
        this._createInstance(container, constructor);
      }.bind(this));
    }
  });

  theme.Product = function () {
    function Product(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.zoomPictures = [];
      this.settings = {
        // Breakpoints from src/stylesheets/global/variables.scss.liquid
        mediaQueryMediumUp: 'screen and (min-width: 750px)',
        mediaQuerySmall: 'screen and (max-width: 749px)',
        bpSmall: false,
        namespace: '.slideshow-' + sectionId,
        sectionId: sectionId,
        sliderActive: false,
        zoomEnabled: false
      };
      this.selectors = {
        addToCart: '[data-add-to-cart]',
        form: '#ProductForm--' + sectionId,
        variantsJson: 'VariantsJson--' + sectionId,
        loader: '[data-loader]',
        quantityWrapper: '[data-quantity-wrapper]',
        quantity: '[data-quantity-input]',
        SKU: '.variant-sku',
        originalSelectorId: '#ProductSelect--' + sectionId,
        errorMessageWrapper: '[data-error-message-wrapper]',
        errorMessageText: '[data-error-message-text]',
        productMediaWrapper: '[data-product-single-media-wrapper]',
        productGallerySelector: '#product-gallery-' + sectionId,
        singleOptionSelector: '.variant-selection__input--' + sectionId,
        shopifyPaymentButton: '.shopify-payment-button',
        productAvailable: '[data-product-available]',
        productUnavailable: '[data-product-unavailable]',
        priceContainer: '[data-price]',
        regularPrice: '[data-regular-price]',
        salePrice: '[data-sale-price]',
        productPolicies: '[data-product-policies]',
        storeAvailabilityContainer: '[data-store-availability-container]',
        subscriptionToggleInput: '[data-subscription-toggle]',
        subscriptionExpandable: '.product-form__subscription-expandable',
        subscriptionOptions: '[data-subscription-options]',
        priceSubscriptionFrequency: '[data-price-subscription-frequency]',
        subscriptionCoffee: '.product-form__subscription-coffee'
      };
      this.classes = {
        cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
        hidden: 'hide',
        visibilityHidden: 'visibility-hidden',
        inputError: 'input--error',
        jsZoomEnabled: 'js-zoom-enabled',
        productOnSale: 'price--on-sale'
      };
      this.eventHandlers = {};
      this.quantityWrapper = container.querySelector(this.selectors.quantityWrapper);
      this.quantityInput = container.querySelector(this.selectors.quantity);
      this.errorMessageWrapper = container.querySelector(this.selectors.errorMessageWrapper);
      this.errorMessageText = container.querySelector(this.selectors.errorMessageText);
      this.productForm = container.querySelector(this.selectors.form);
      this.addToCart = container.querySelector(this.selectors.addToCart);
      this.subscriptionExpandable = container.querySelector(this.selectors.subscriptionExpandable);
      this.subscriptionOptions = container.querySelector(this.selectors.subscriptionOptions);
      this.subscriptionCoffee = container.querySelector(this.selectors.subscriptionCoffee + ':not(.hide)');
      this.productAvailable = container.querySelector(this.selectors.productAvailable);
      this.productUnavailable = container.querySelector(this.selectors.productUnavailable);
      this.singleOptionSelectors = container.querySelectorAll(this.selectors.singleOptionSelector);
      this.shopifyPaymentButton = container.querySelector(this.selectors.shopifyPaymentButton);
      this.priceContainer = container.querySelector(this.selectors.priceContainer);
      this.productPolicies = container.querySelector(this.selectors.productPolicies); // this.loader = this.addToCart.querySelector(this.selectors.loader);

      var toggleInput = container.querySelector(this.selectors.subscriptionToggleInput + ':checked');
      this.isSubscribing = toggleInput && toggleInput.value == '1';
      this.productState = {
        available: true,
        soldOut: false,
        onSale: false
      };
      this.hideAddToCart = container.dataset.hideAddToCart == 'true';

      this._stringOverrides();

      this._initVariants();

      this._initForm();

      this._initSubscriptions();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      _stringOverrides: function _stringOverrides() {
        theme.productStrings = theme.productStrings || {};
        theme.strings = Object.assign({}, theme.strings, theme.productStrings);
      },
      _initForm: function _initForm() {
        this.container.querySelector(this.selectors.form).addEventListener('submit', this._handleAddToCart.bind(this));
      },
      _initSubscriptions: function _initSubscriptions() {
        if (!this.subscriptionOptions) return;
        $(this.selectors.subscriptionToggleInput).on('change', this._handleToggleSubscription.bind(this));
        $(this.selectors.subscriptionOptions).on('change', this._handleChangeSubscription.bind(this));
      },
      _handleToggleSubscription: function _handleToggleSubscription(event) {
        this.isSubscribing = event.currentTarget.value == '1';
        this.subscriptionExpandable.classList.toggle('hide', !this.isSubscribing);
        $(this.selectors.priceSubscriptionFrequency).toggleClass('hide', !this.isSubscribing);

        if (this.isSubscribing) {
          this._updatePriceSubscriptionFrequency();
        }
      },
      _handleChangeSubscription: function _handleChangeSubscription() {
        this._updatePriceSubscriptionFrequency();
      },
      _updatePriceSubscriptionFrequency: function _updatePriceSubscriptionFrequency() {
        var selectedIndex = this.subscriptionOptions.selectedIndex;
        var subscriptionValue = this.subscriptionOptions.options[selectedIndex].innerHTML.trim();
        $(this.selectors.priceSubscriptionFrequency).text('/ ' + subscriptionValue);
      },
      _getSubscriptionCoffeeFromOptions: function _getSubscriptionCoffeeFromOptions() {
        this.subscriptionCoffee = this.container.querySelector(this.selectors.subscriptionCoffee + ':not(.hide)');
        if (!this.subscriptionCoffee) return null;
        var subscriptionCoffeeJson = this.subscriptionCoffee.dataset.subscriptionCoffee;
        var subscriptionCoffee = JSON.parse(subscriptionCoffeeJson);
        var options = [];
        /* Build an array of the selected input values in the product form. */

        this.singleOptionSelectors.forEach(function (option) {
          if (!option.value) return;

          if (option.type === 'radio' || option.type === 'checkbox') {
            if (!option.checked) return;
          }

          options.push(option.value);
        });
        /* Find a variant that matches all of those selected input values. */

        var variant = subscriptionCoffee.variants.find(function (variant) {
          return options.every(function (option) {
            return variant.title.toLowerCase().includes(option.toLowerCase());
          });
        });
        return variant;
      },

      /** Rules are hard coded at the moment as
       * we do not have access to any of the of the details of the 'Shopify Discounts'
       * ---- Current Deal ---
       * Deal: Easter Deal
       * Details: Spend over 70 dollars from products only from the
       * Coffee Collection. If the customer cart is equal to or over 70 dollars
       * add the Free Drinking chocolate. This deal is only only applied once.
       */
      _checkIfCartIsValidForDealAndAdd: function _checkIfCartIsValidForDealAndAdd() {
        // Hardcoding the the product ID only because we can't get access to the discount details on shopify.
        // Both product and total discount price
        var drinkingChocolateId = window.location.href.includes('staging') ? 42241915027655 : 41707646222508;
        var discountTotal = 70;
        fetch('/cart.json').then(function (res) {
          return res.json();
        }).then(function (cart) {
          /** Valid items only have the _track property. We will only be looking those line_item
           * prices. Get the sub total of those line items. If the total of those items is 70 or over.
           * Add the chocolate.
           */
          var validItems = cart.items.filter(function (line) {
            return line.properties['_track'];
          });
          var validItemsTotal = validItems.reduce(function (validItemsTotal, line) {
            return validItemsTotal += line.line_price;
          }, 0);
          var cartTotal = validItemsTotal / 100; //If cart total is below 70 dollars. Do not apply discount.

          if (cartTotal < discountTotal) {
            return;
          } //If cart contains free line item already.
          //Do not attempt to re-add.


          if (cart.items.find(function (item) {
            return item.id === drinkingChocolateId;
          })) {
            return;
          }

          var items = [{
            id: drinkingChocolateId,
            quantity: 1,
            properties: {
              _EASTER_DEAL: true
            }
          }];
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            window.reloadCartPopup();
          });
        });
      },

      /** Rules are hard coded at the moment as
       * we do not have access to any of the of the details of the 'Shopify Discounts'
       * ---- Current Deal ---
       * Deal: Easter Deal
       * Details: Checks to see if the date is within the valid date range.
       * If product within date range, check to see if product is valid.
       * Double checks to make sure the product hasn't been added through the quickview module.
       */
      _dealApplies: function _dealApplies(data) {
        return false;
        var startDate = new Date('2025-04-01T10:00:00Z');
        var endDate = new Date('2025-04-30T13:59:00Z');
        var now = new Date(); // Check to see if deal is with valid date range

        if (now >= startDate && now <= endDate) {
          // Check to see if product is in valid collection.
          var isValidProduct = document.querySelector('input#cart-sub-total');

          if (!isValidProduct) {
            var _data$id, _data$id$id;

            // Check to see if product is in quick-view and is valid collection.
            var productId = (_data$id = data['id']) === null || _data$id === void 0 ? void 0 : (_data$id$id = _data$id.id) === null || _data$id$id === void 0 ? void 0 : _data$id$id.split('--').pop();
            var cartTotalQuickView = document.querySelector("input#cart-sub-total-".concat(productId));

            if (cartTotalQuickView) {
              return true;
            }

            return false;
          }

          return true;
        }

        return false;
      },
      _handlePromoBannerUpdate: function _handlePromoBannerUpdate(cart, quantity) {
        var promotion = document.querySelector('input#promo_deal');
        if (!promotion) return;

        var _promotion$value$spli = promotion.value.split(','),
            _promotion$value$spli2 = _slicedToArray(_promotion$value$spli, 2),
            amount = _promotion$value$spli2[0],
            successMessage = _promotion$value$spli2[1];

        var preText = promotion.getAttribute('data-promo-pre');
        var postText = promotion.getAttribute('data-promo-post');
        var totalAmount = parseFloat(parseFloat(amount).toFixed(2));
        var recentItemPrice = cart.items.filter(function (item) {
          var _item$properties;

          return item === null || item === void 0 ? void 0 : (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._coffee;
        }).reduce(function (acc, item) {
          return acc += item.price * quantity;
        }, 0) / 100; // update total

        var bar = document.querySelector('div#promotion-banner');
        var totalRemainingPromo = document.querySelector('b#total_remaining_promo');
        if (!bar || !totalRemainingPromo) return;
        var validTotal = parseFloat(totalRemainingPromo.innerText);
        console.log(totalAmount, validTotal, recentItemPrice);
        var totalForPromo = parseFloat(validTotal - recentItemPrice).toFixed(2);
        var message = totalForPromo <= 0 ? "".concat(successMessage) || 'FREE SHIPPING ' : "".concat(preText || 'ONLY', " $<b id=\"total_remaining_promo\">").concat(totalForPromo, "</b> ").concat(postText || 'FROM GETTING FREE SHIPPING (COFFEE PRODUCTS)');
        bar.innerHTML = message; // of over threshold update
      },
      _handleAddToCart: function _handleAddToCart(event) {
        var _this2 = this;

        var self = this;
        event.preventDefault();
        var formData = new FormData(event.target);
        var id = '';
        var quantity = 0;
        var selling_plan = null;
        var properties = {};
        var roastType = null;
        console.log(formData.get('cat-coffee'), ' resize the image .  ');

        var applyDeal = this._dealApplies(event.currentTarget.elements);

        if (this.hideAddToCart) return;

        var _iterator = _createForOfIteratorHelper(formData.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;

            if (pair[0].toLowerCase() === 'roast type') {
              roastType = pair[1].toLowerCase();
            }

            if (pair[0] === 'id') {
              id = pair[1];
            }

            if (pair[0] === 'quantity') {
              quantity = pair[1];
            }

            if (self.isSubscribing) {
              if (pair[0] === 'selling_plan') {
                selling_plan = pair[1];
              } else {
                if (roastType == 'espresso roast' && pair[0] == 'selling_plan_espresso') {
                  selling_plan = pair[1];
                } else if (roastType == 'filter roast' && pair[0] == 'selling_plan_filter') {
                  selling_plan = pair[1];
                }
              }
            }

            if (pair[0] === 'properties[preorder]' && pair[1] === 'true') {
              properties.preorder = true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (self.subscriptionCoffee && self.isSubscribing) {
          var subscriptionCoffee = self._getSubscriptionCoffeeFromOptions();

          if (!subscriptionCoffee) throw Error('Unable to subscribe to that coffee at this moment.');
          properties.preferred_coffee = id;
          id = subscriptionCoffee.id;
        }

        if (formData.get('cat-coffee')) {
          properties = _objectSpread(_objectSpread({}, properties), {}, {
            _coffee: 1
          });
        }

        var isWholesaleCustomer = document.querySelector('input#wholesale-customer-input') ? true : false;

        if (isWholesaleCustomer) {
          properties = _objectSpread(_objectSpread({}, properties), {}, {
            __wholesale_item: 1
          });
        }

        var items = [{
          id: id,
          quantity: quantity,
          selling_plan: selling_plan,
          properties: properties
        }]; // If item is valid, add tracking

        if (applyDeal && !self.isSubscribing) {
          items[0].properties['_track'] = 1;
        }

        self._hideErrorMessage();

        self._handleButtonLoadingState(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: items
          })
        }).then(function (response) {
          return response.json().then(function (data) {
            if (response.ok) return data;
            throw Error(data.description);
          });
        }).then(function (data) {
          var isB2B = document.body.classList.contains('is-b2b');

          _this2._handlePromoBannerUpdate(data, quantity); // Check if item being added is in valid collection of Coffee.


          if (!isB2B && applyDeal && !self.isSubscribing) {
            _this2._checkIfCartIsValidForDealAndAdd();
          }

          if (isB2B && window.openAddedToCartModal) {
            window.openAddedToCartModal();
          } else {
            window.openCartPopup();
          }

          window.reloadCartPopup();
        })["catch"](function (error) {
          self._showErrorMessage(error.message);
        })["finally"](function () {
          self._handleButtonLoadingState(false);
        });
      },
      _initVariants: function _initVariants() {
        var variantJson = document.getElementById(this.selectors.variantsJson);

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var options = {
          container: this.container,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
        this.variants = new theme.Variants(options);
        this.eventHandlers.updateVariant = this._updateVariant.bind(this);
        this.eventHandlers.updatePrice = this._updatePrice.bind(this);
        this.eventHandlers.updateAvailability = this._updatePrice.bind(this);
        this.container.addEventListener('variantChange', this.eventHandlers.updateVariant);
        this.container.addEventListener('variantPriceChange', this.eventHandlers.updatePrice);
      },
      _handleButtonLoadingState: function _handleButtonLoadingState(isLoading) {
        if (isLoading) {
          var revertText = this.addToCart.innerText;
          this.addToCart.innerText = 'LOADING...';
          this.addToCart.setAttribute('data-revert-text', revertText);
          this.addToCart.setAttribute('disabled', true);
          this.quantityInput.setAttribute('disabled', true); // this.loader.classList.remove(this.classes.hidden);

          if (this.shopifyPaymentButton) {
            this.shopifyPaymentButton.setAttribute('disabled', true);
          }
        } else {
          var revertText = this.addToCart.getAttribute('data-revert-text');
          this.addToCart.innerText = revertText || 'BUY NOW';
          this.addToCart.removeAttribute('data-revert-text');
          this.addToCart.removeAttribute('disabled');
          this.quantityInput.removeAttribute('disabled'); // this.loader.classList.add(this.classes.hidden);

          if (this.shopifyPaymentButton) {
            this.shopifyPaymentButton.removeAttribute('disabled');
          }
        }
      },
      _showErrorMessage: function _showErrorMessage(errorMessage) {
        if (!this.errorMessageWrapper) return;
        this.errorMessageText.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove('hide');
        this.errorMessageWrapper.removeAttribute('aria-hidden');
      },
      _hideErrorMessage: function _hideErrorMessage() {
        if (!this.errorMessageWrapper) return;
        this.errorMessageWrapper.classList.add('hide');
        this.errorMessageWrapper.setAttribute('aria-hidden', true);
        this.errorMessageText.innerHTML = '';
      },
      _getVariantOptionList: function _getVariantOptionList(variantOptions) {
        var variantOptionListHTML = '';
        variantOptions.forEach(function (variantOption) {
          variantOptionListHTML = variantOptionListHTML + '<li class="product-details__item product-details__item--variant-option">' + variantOption.name + ': ' + variantOption.value + '</li>';
        });
        return variantOptionListHTML;
      },
      _switchMedia: function _switchMedia(mediaId) {},
      _enableAddToCart: function _enableAddToCart() {
        this.productAvailable.classList.remove('hide');
        this.productAvailable.removeAttribute('aria-disabled');
        this.productUnavailable.classList.add('hide');
        this.productUnavailable.setAttribute('aria-disabled', true);
      },
      _disableAddToCart: function _disableAddToCart() {
        this.productAvailable.classList.add('hide');
        this.productAvailable.setAttribute('aria-disabled', true);
        this.productUnavailable.classList.remove('hide');
        this.productUnavailable.removeAttribute('aria-disabled');
      },
      _updateAddToCart: function _updateAddToCart() {
        if (this.hideAddToCart) return;

        if (!this.productState.available || this.productState.soldOut) {
          this._disableAddToCart();

          return;
        }

        this._enableAddToCart();
      },
      _setProductState: function _setProductState(variant) {
        if (this.hideAddToCart) return;

        if (!variant) {
          this.productState.available = false;
          return;
        }

        this.productState.available = true;
        this.productState.soldOut = !variant.available;
        this.productState.onSale = variant.compare_at_price > variant.price;
      },
      _updateMedia: function _updateMedia(evt) {
        var variant = evt.detail.variant;
        var mediaId = variant.featured_media.id;

        this._switchMedia(mediaId);
      },
      _hidePriceComponent: function _hidePriceComponent() {
        this.priceContainer.classList.add(this.classes.productUnavailable);
        this.priceContainer.setAttribute('aria-hidden', true);

        if (this.productPolicies) {
          this.productPolicies.classList.add(this.classes.visibilityHidden);
        }
      },
      _updatePriceComponentStyles: function _updatePriceComponentStyles(evt) {
        var variant = evt.detail.variant;

        if (!this.productState.available) {
          this._hidePriceComponent();

          return;
        }

        if (this.productState.soldOut) {
          this.priceContainer.classList.add(this.classes.productSoldOut);
        } else {
          this.priceContainer.classList.remove(this.classes.productSoldOut);
        }

        if (this.productState.onSale) {
          this.priceContainer.classList.add(this.classes.productOnSale);
        } else {
          this.priceContainer.classList.remove(this.classes.productOnSale);
        }

        this.priceContainer.classList.remove(this.classes.productUnavailable);
        this.priceContainer.removeAttribute('aria-hidden');

        if (this.productPolicies) {
          this.productPolicies.classList.remove(this.classes.visibilityHidden);
        }
      },
      _updatePrice: function _updatePrice(evt) {
        var variant = evt.detail.variant;
        var formattedPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
        $(this.container).find(this.selectors.regularPrice).html(formattedPrice);
      },
      _updateSubscription: function _updateSubscription(variant) {
        var isEspressoRoast = variant.title.toLowerCase().includes('espresso roast');
        var isFilterRoast = variant.title.toLowerCase().includes('filter roast');
        var espressoSellingPlan = this.container.querySelector('#input--selling_plan_espresso');
        var filterSellingPlan = this.container.querySelector('#input--selling_plan_filter');
        var espressoInfoBox = this.container.querySelector(this.selectors.subscriptionCoffee + '--espresso');
        var filterInfoBox = this.container.querySelector(this.selectors.subscriptionCoffee + '--filter');

        if (isEspressoRoast) {
          if (espressoSellingPlan) espressoSellingPlan.classList.remove('hide');
          if (espressoInfoBox) espressoInfoBox.classList.remove('hide');
          if (filterSellingPlan) filterSellingPlan.classList.add('hide');
          if (filterInfoBox) filterInfoBox.classList.add('hide');
        } else if (isFilterRoast) {
          if (filterSellingPlan) filterSellingPlan.classList.remove('hide');
          if (filterInfoBox) filterInfoBox.classList.remove('hide');
          if (espressoSellingPlan) espressoSellingPlan.classList.add('hide');
          if (espressoInfoBox) espressoInfoBox.classList.add('hide');
        }
      },
      _updateVariant: function _updateVariant(evt) {
        var variant = evt.detail.variant;

        this._hideErrorMessage();

        this._setProductState(variant);

        this._updateAddToCart();

        this._updateSubscription(variant);

        function updateIdValue() {
          var idInput = this.container.querySelector(this.selectors.originalSelectorId);

          if (idInput) {
            idInput.value = variant.id.toString();
          }
        }
        /* For some reason if you call it in the same cycle it will be overriden by the original value, doing this correctly sets it */


        setTimeout(updateIdValue.bind(this), 0);
      },
      _updateSKU: function _updateSKU(evt) {
        var variant = evt.detail.variant; // Update the sku

        var sku = document.querySelector(this.selectors.SKU);
        if (!sku) return;
        sku.innerHTML = variant.sku;
      },
      onUnload: function onUnload() {
        this.container.removeEventListener('variantChange', this.eventHandlers.updateAvailability);
        this.container.removeEventListener('variantImageChange', this.eventHandlers.updateMedia);
        this.container.removeEventListener('variantPriceChange', this.eventHandlers.updatePrice);
        this.container.removeEventListener('variantSKUChange', this.eventHandlers.updateSKU);
        theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
        theme.ProductModel.removeSectionModels(this.settings.sectionId);

        if (this.mqlSmall) {
          this.mqlSmall.removeListener(this.initMobileBreakpoint);
        }

        if (this.mqlMediumUp) {
          this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
        }
      }
    });
    return Product;
  }();

  theme.handleReorder = function (order) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: order
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (response.ok) return data;
        throw Error(data.description);
      });
    }).then(function (data) {
      window.location.href = '/cart';
    })["catch"](function (error) {
      var errorMessageContainer = document.querySelector('.product-form__error');
      var errorMessage = document.querySelector('.product-form__error-text');
      errorMessageContainer.classList.remove('hide');
      errorMessage.innerText = 'Unable to place order due to unavailable stock';
    });
  };

  theme.Currency = function () {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;

        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  }();

  theme.Variants = function () {
    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.originalSelectorId = options.originalSelectorId;
      this.singleOptions = this.container.querySelectorAll(options.singleOptionSelector);
      this.currentVariant = this._getVariantFromOptions();
      this.singleOptions.forEach(function (option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this));
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function _getCurrentOptions() {
        var result = [];
        this.singleOptions.forEach(function (option) {
          var type = option.getAttribute('type');
          var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

          if (!isRadioOrCheckbox || option.checked) {
            result.push({
              value: option.value,
              index: option.getAttribute('data-index')
            });
          }
        });
        return result;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function _getVariantFromOptions() {
        var selectedValues = this._getCurrentOptions();

        var variants = this.variants;
        var found = variants.find(function (variant) {
          return selectedValues.every(function (values) {
            return variant[values.index] === values.value;
          });
        });
        return found;
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function _onSelectChange() {
        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));

        if (!variant) {
          return;
        }

        this._updatePrice(variant);

        this.currentVariant = variant;

        this._updateHistoryState(variant);
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function _updateImages(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function _updatePrice(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function _updateSKU(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        }));
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function _updateHistoryState(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({
          path: newurl
        }, '', newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function _updateMasterSelect(variant) {
        var masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;
        masterSelect.value = variant.id;
      }
    });
    return Variants;
  }();

  theme.storefrontApi = {
    createCustomerAccessToken: function createCustomerAccessToken(email, password) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n            mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {\n              customerAccessTokenCreate(input: $input) {\n                customerAccessToken {\n                  accessToken\n                  expiresAt\n                }\n                customerUserErrors {\n                  code\n                  field\n                  message\n                }\n              }\n            }\n          ",
          variables: {
            input: {
              email: email,
              password: password
            }
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAccessTokenCreate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customerAccessToken.accessToken;
      });
    },
    updateCustomer: function updateCustomer(accessToken, values) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n            mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {\n              customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {\n                customer {\n                  id\n                  firstName\n                  lastName\n                  phone\n                  acceptsMarketing\n                  email\n                }\n                customerAccessToken {\n                  accessToken\n                  expiresAt\n                }\n                customerUserErrors {\n                  code\n                  field\n                  message\n                }\n              }\n            }\n          ",
          variables: {
            customerAccessToken: accessToken,
            customer: values
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerUpdate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customer;
      });
    },
    updateCustomerAddress: function updateCustomerAddress(accessToken, addressID, values) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerAddressUpdate($customerAccessToken: String!, $id: ID!, $address: MailingAddressInput!) {\n                customerAddressUpdate(\n                  customerAccessToken: $customerAccessToken\n                  id: $id\n                  address: $address\n                ) {\n                  customerAddress {\n                    id\n                  }\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            id: addressID,
            address: values
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAddressUpdate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customerAddress;
      });
    },
    deleteCustomerAddress: function deleteCustomerAddress(accessToken, addressID) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerAddressDelete($id: ID!, $customerAccessToken: String!) {\n                customerAddressDelete(id: $id, customerAccessToken: $customerAccessToken) {\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                  deletedCustomerAddressId\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            id: addressID
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerAddressDelete;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.deletedCustomerAddressId;
      });
    },
    updateCustomerDefaultAddress: function updateCustomerDefaultAddress(accessToken, addressID) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerDefaultAddressUpdate($addressId: ID!, $customerAccessToken: String!) {\n                customerDefaultAddressUpdate(addressId: $addressId, customerAccessToken: $customerAccessToken) {\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                  customer {\n                    id\n                  }\n                }\n              }\n          ",
          variables: {
            customerAccessToken: accessToken,
            addressId: addressID
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerDefaultAddressUpdate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customer;
      });
    },
    customerActivate: function customerActivate(token, customerID) {
      return theme.utils.fetch(theme.ENV.storefrontApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': theme.ENV.storefrontAccessToken
        },
        body: JSON.stringify({
          query: "\n              mutation customerActivate($id: ID!, $input: CustomerActivateInput!) {\n                customerActivate(id: $id, input: $input) {\n                  customerUserErrors {\n                    code\n                    field\n                    message\n                  }\n                  customerAccessToken {\n                    accessToken\n                  }\n                }\n              }\n          ",
          variables: {
            id: customerID,
            input: token
          }
        })
      }).then(function (response) {
        if (response.errors) throw response.errors;
        var data = response.data.customerActivate;
        if (data.customerUserErrors && data.customerUserErrors.length > 0) throw data.customerUserErrors;
        return data.customer;
      });
    }
  };

  theme.initQuickview = function () {
    var selectors = {
      openButton: '[data-quickview-open-button]',
      modal: '.product-quickview',
      closeButton: '.product-quickview__close',
      backdrop: '.product-quickview__backdrop',
      variantInput: '.product-quickview__variant-input'
    };
    $(selectors.openButton).on('click', handleOpen).addClass('quickview-active');

    theme.destroyQuickview = function () {
      $(selectors.openButton).off('click', handleOpen);
    };

    function handleOpen(event) {
      var productId = event.currentTarget.dataset.productId;
      if (!productId) return true;
      event.preventDefault();
      event.stopPropagation();
      openModal(productId);
      return false;
    }

    function openModal(productId) {
      var modal = $(selectors.modal + '--' + productId);
      modal.addClass('open');
      theme.a11y.lockScrolling();

      function handleClose() {
        modal.removeClass('open');
        theme.a11y.unlockScrolling();
        modal.find(selectors.closeButton).off('click', handleClose);
        modal.find(selectors.backdrop).off('click', handleClose);
      }

      modal.find(selectors.closeButton).on('click', handleClose);
      modal.find(selectors.backdrop).on('click', handleClose);
    }
  };

  $(function () {
    var _Shopify, _Shopify$theme, _Shopify$theme$name, _Shopify2;

    theme.sections = new theme.Sections();
    theme.sections.register('product', theme.Product);
    theme.initQuickview();

    if ((_Shopify = Shopify) !== null && _Shopify !== void 0 && (_Shopify$theme = _Shopify.theme) !== null && _Shopify$theme !== void 0 && (_Shopify$theme$name = _Shopify$theme.name) !== null && _Shopify$theme$name !== void 0 && _Shopify$theme$name.includes(' Dev')) {
      document.body.classList.add('is-dev');
    }

    if ((_Shopify2 = Shopify) !== null && _Shopify2 !== void 0 && _Shopify2.designMode) {
      document.body.classList.add('is-theme-editor');
    }
  });
})(jQuery);
/* Alert */


$(function () {
  var selectors = {
    wrapper: '.alert',
    dismissButton: '.alert__dismiss'
  };
  $(selectors.dismissButton).on('click', handleClickDismiss);

  function handleClickDismiss(event) {
    $(event.currentTarget).closest(selectors.wrapper).addClass('hide').attr('aria-hidden', true);
  }
});
/* Disclosure */

$(function () {
  var selectors = {
    openButton: '.disclosure__open-button',
    openButtonLink: '.disclosure__open-button a'
  };

  function init() {
    $(selectors.openButton).on('click', handleToggle);
  }

  function destroy() {
    $(selectors.openButton).off('click', handleToggle);
  }

  $(selectors.openButtonLink).on('click', handleChildClick);

  function handleToggle(event) {
    var ANIMATION_DURATION_MS = 200;
    var body = $(event.currentTarget).next();
    var isOpening = body.is(':hidden');
    body.slideToggle(ANIMATION_DURATION_MS);
    $(event.target).toggleClass('open');

    if (isOpening) {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      /* Only control scroll if on mobile */

      if (!isMobile) return;
      /* Offset the scroll by the header height */

      var headerHeight = window.getComputedStyle(document.documentElement).getPropertyValue('--headerHeightSlim');
      headerHeight = parseInt(headerHeight.replace('px', ''), 10);
      var scrollY = event.target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      /* Once the dropdown animation is finished, scroll what was just clicked into view. */

      setTimeout(function () {
        window.scrollTo({
          top: scrollY,
          behavior: 'smooth'
        });
      }, ANIMATION_DURATION_MS);
    }
  }

  function handleChildClick(event) {
    /* prevent links inside the button from opening the disclosure */
    event.stopPropagation();
  }

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', destroy);
});
/* Slide Animation */

$(function () {
  var scrollElements = document.querySelectorAll('.js-scroll');

  var elementInView = function elementInView(el) {
    var dividend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var elementTop = el.getBoundingClientRect().top;
    return elementTop <= (window.innerHeight || document.documentElement.clientHeight) / dividend;
  };

  var elementOutofView = function elementOutofView(el) {
    var elementTop = el.getBoundingClientRect().top;
    return elementTop > (window.innerHeight || document.documentElement.clientHeight);
  };

  var displayScrollElement = function displayScrollElement(element) {
    element.classList.add('scrolled');
  };

  var hideScrollElement = function hideScrollElement(element) {
    element.classList.remove('scrolled');
  };

  var handleScrollAnimation = function handleScrollAnimation() {
    scrollElements.forEach(function (el) {
      if (elementInView(el, 1.25)) {
        displayScrollElement(el);
      } else if (elementOutofView(el)) {
        hideScrollElement(el);
      }
    });
  }; //onload


  handleScrollAnimation();
  window.addEventListener('scroll', function () {
    handleScrollAnimation();
  });
});
/* globo form general setting */

$(function () {
  $(document).on('click', '.globo-form-app form button.submit', function (e) {
    $('[placeholder=conditional-email]').val($('[name=email]').val());

    if ($('#81315-select-4').val() != 'Not currently working in a cafe, but looking for Barista employment' && $('[name=radio-2]:checked').val() != 'YES') {
      $('#hidden-2').val('');
    }
  });
  document.addEventListener('globo.formbuilder.form.loaded', applyCustomStyles);

  function applyCustomStyles() {
    $('*[placeholder*=hidden-]').closest('.globo-form-control').hide();
    $('*[placeholder=conditional-email]').closest('.globo-form-control').css('display', 'none!important').css('opacity', '0');
    $('input[placeholder*=hidden-]').each(function () {
      var id = $(this).attr('placeholder');
      $(this).val($('#' + id).val());
    });
    $('#81313-select-2').closest('.globo-form-control').hide();
    $('#81313-select').on('change', function () {
      if ($(this).val() == 'Western Australia') {
        $('#81313-select-2').val('training.wa@fivesenses.com.au');
      } else if ($(this).val() == 'New South Wales') {
        $('#81313-select-2').val('training.nsw@fivesenses.com.au');
      } else if ($(this).val() == 'Victoria') {
        $('#81313-select-2').val('training.vic@fivesenses.com.au');
      } else if ($(this).val() == 'South Australia') {
        $('#81313-select-2').val('training.sa@fivesenses.com.au');
      }
    });
    var q = document.getElementById('81218-select');
    var wholesale = document.getElementById('81335-text');
    var positionState = document.getElementById('81334-select');
    var page = window.location.href;
    var attendee = document.getElementById('81315-datetime');

    if (attendee) {
      var today = new Date();
      var date = theme.utils.formatDate(today);
      attendee.value = date;
    }

    if (q) {
      applyWholeSaleFormStyles();

      if (page.includes('marco')) {
        q.value = 'Marco Products';
        q.dispatchEvent(new Event('change'));
      } else if (page.includes('synesso')) {
        q.value = 'Synesso Espresso Machines';
        q.dispatchEvent(new Event('change'));
      } else if (page.includes('contact') || page.includes('mahlkonig') || page.includes('mythos') || page.includes('mazzer')) {
        q.value = 'Using Five Senses in my Cafe';
        q.dispatchEvent(new Event('change'));
      }
    }

    if (wholesale) {
      var updateStyle = function updateStyle() {
        if (document.querySelector('input[name="radio"]:checked')) {
          business_name.parentElement.style.display = 'block';
          street.parentElement.style.display = 'block';
          suburb.parentElement.style.display = 'block';
          state.parentElement.style.display = 'block';
          how.parentElement.style.display = 'block';
          info.parentElement.style.display = 'block';
        }
      };

      var radio = document.querySelector('input[name="radio"]');
      radio.addEventListener('change', updateStyle);
      var business_name = document.getElementById('81335-text-2');
      var street = document.getElementById('81335-text-3');
      var suburb = document.getElementById('81335-text-4');
      var state = document.getElementById('81335-select-2');
      var how = document.getElementById('81335-select-3');
      var info = document.getElementById('81335-textarea-2');

      if (!document.querySelector('input[name="radio"]:checked')) {
        business_name.parentElement.style.display = 'none';
        street.parentElement.style.display = 'none';
        suburb.parentElement.style.display = 'none';
        state.parentElement.style.display = 'none';
        how.parentElement.style.display = 'none';
        info.parentElement.style.display = 'none';
      }
    }

    if (positionState) {
      if (page.includes('vic')) {
        positionState.value = 'Victoria';
      } else if (page.includes('wa')) {
        positionState.value = 'Western Australia';
      } else if (page.includes('sa')) {
        positionState.value = 'South Australia';
      } else if (page.includes('nsw')) {
        positionState.value = 'New South Wales';
      } else if (page.includes('nt')) {
        positionState.value = 'Northern Territory';
      } else if (page.includes('act')) {
        positionState.value = 'Australian Capital Territory';
      } else if (page.includes('tas')) {
        positionState.value = 'Tasmania';
      } else if (page.includes('qld')) {
        positionState.value = 'Queensland';
      } else {
        positionState.value = 'International';
      }

      positionState.dispatchEvent(new Event('change'));
    }
  }

  function applyWholeSaleFormStyles() {
    var question = document.getElementById('81282-select');
    if (question) question.addEventListener('change', setPlaceHolder);
    var msgTextarea = document.getElementById('81282-textarea');

    function setPlaceHolder(event) {
      var value = event.target.value;

      if (value == 'Help! I need some advice on buying coffee equipment for home.') {
        msgTextarea.setAttribute('placeholder', "Tell us what kind of equipment you're after. Are you setting up or upgrading? Is espresso or filter coffee your poison?");
      } else if (value == "There's so much delicious coffee...which one should I choose?") {
        msgTextarea.setAttribute('placeholder', 'What equipment do you make your coffee with? What tastes get you excited; heavy body? bright and tangy? Fruity?');
      } else if (value == "I'm having some problems with my online account.") {
        msgTextarea.setAttribute('placeholder', 'Are you having a problem submitting an order? Forgotten your password?');
      } else if (value == "I'd like to chat with the Tech Service team about my equipment.") {
        msgTextarea.setAttribute('placeholder', "What fangdangle widget isn't working properly?");
      } else if (value == "I'd like to talk Sponsorship or Fundraising.") {
        msgTextarea.setAttribute('placeholder', 'Tell us some more about your initiative. How do you see it aligning with the Five Senses values?');
      } else if (value == 'My choice is not listed here.') {
        msgTextarea.setAttribute('placeholder', 'Tell us some more about what you are after.');
      }
    }

    var q = document.getElementById('81218-select');
    if (q) q.addEventListener('change', setCaption);
    var msg = document.getElementById('jet-down');
    var textarea = document.getElementById('81218-textarea');
    var business_name = document.getElementById('81218-text-6');
    var street = document.getElementById('81218-text-3');
    var suburb = document.getElementById('81218-text-4');
    var state = document.getElementById('81218-select-2');
    var how = document.getElementById('81218-select-3');
    var info = document.getElementById('81218-textarea-2');
    var other = document.getElementById('81218-text-5');
    var radio = document.querySelector('input[name="radio"]');
    if (radio) radio.addEventListener('change', updateStyle);

    function setCaption(event) {
      var value = event.target.value;

      if (value == 'Using Five Senses in my Office , School or Church') {
        msg.style.display = 'none';
      } else {
        msg.style.display = 'block';
      }

      if (value == 'Using Five Senses in my Cafe') {
        textarea.parentElement.style.display = 'none';

        if (!document.querySelector('input[name="radio"]:checked')) {
          business_name.parentElement.style.display = 'none';
          street.parentElement.style.display = 'none';
          street.parentElement.style.display = 'none';
          suburb.parentElement.style.display = 'none';
          state.parentElement.style.display = 'none';
          how.parentElement.style.display = 'none';
          other.parentElement.style.display = 'none';
          info.parentElement.style.display = 'none';
        }
      } else {
        textarea.parentElement.style.display = 'block';
        suburb.parentElement.style.display = 'block';
        state.parentElement.style.display = 'block';
        how.parentElement.style.display = 'block'; // info.parentElement.style.display ="block";
      }
    }

    function updateStyle() {
      if (document.querySelector('input[name="radio"]:checked')) {
        suburb.parentElement.style.display = 'block';
        state.parentElement.style.display = 'block';
        how.parentElement.style.display = 'block';
        info.parentElement.style.display = 'block';
      }
    }
  }
});

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

document.addEventListener('globo.formbuilder.scripts.loaded', function () {
  setTimeout(function () {
    var params = {};

    if (location.search) {
      var parts = location.search.substring(1).split('&');

      for (var i = 0; i < parts.length; i++) {
        var nv = parts[i].split('=');
        if (!nv[0]) continue;
        params[nv[0]] = nv[1] || true;
      }
    }

    if ($('input[value="utm_medium"]').length > 0) $('input[value="utm_medium"]').val(params.utm_medium);
    if ($('input[value="utm_campaign"]').length > 0) $('input[value="utm_campaign"]').val(params.utm_campaign);
    if ($('input[value="utm_source"]').length > 0) $('input[value="utm_source"]').val(params.utm_source);
    if ($('input[value="utm_content"]').length > 0) $('input[value="utm_content"]').val(params.utm_content);
    if ($('input[value="utm_term"]').length > 0) $('input[value="utm_term"]').val(params.utm_term);
  }, 250);
});